import { render, staticRenderFns } from "./EmployeeAdditionalFields.vue?vue&type=template&id=7249177a&scoped=true&lang=pug&"
import script from "./EmployeeAdditionalFields.vue?vue&type=script&lang=ts&"
export * from "./EmployeeAdditionalFields.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeAdditionalFields.vue?vue&type=style&index=0&id=7249177a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7249177a",
  null
  
)

export default component.exports